/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-shadow */
import { dateParser, on, oneToOne, operation, set } from '@/util/zodUtil'
import { z } from 'zod'

const personalInfoZ = ({ operation }: { operation: operation }) => {
  const _ = on(operation)
  // Profile schema
  return z.object({
    id: z.number().transform(_(['update', 'create'])(() => undefined)),
    name: z.string().nullish().transform(_('update')(set)),
    username: z.string().nullish().transform(_('update')(set)),
    nameAr: z.string().nullish().transform(_('update')(set)),
    linkedIn: z.string().nullish().transform(_('update')(set)),
    twitter: z.string().nullish().transform(_('update')(set)),
    identityNo: z.number().nullish().transform(_('update')(set)),
    commercialRecord: z.string().nullish().transform(_('update')(set)),
    nameOnCommercialRecord: z.string().nullish().transform(_('update')(set)),
    logoUrl: z.string().nullish().transform(_('update')(set)),
    role: oneToOne(_),
    email: z.string().nullish().transform(_('update')(set)),
    password: z.string().nullish().transform(_('update')(set)),
    mobileNumber: z.string().nullish().transform(_('update')(set)),
    image: z.string().nullish().transform(_('update')(set)),
    cv: z.string().nullish().transform(_('update')(set)),
    gender: z.enum(['male', 'female']).nullish().transform(_('update')(set)),
    nationality: oneToOne(_).nullish(),
    city: oneToOne(_).nullish(),
    specialty: oneToOne(_).nullish(),
    Qualification: oneToOne(_).nullish(),
    profession: oneToOne(_).nullish(),
    scfhs: z.string().nullish().transform(_('update')(set)),
    scfhsExp: dateParser.transform(_('update')(set)),
    birthday: dateParser.nullish().transform(_('update')(set)),
    createdAt: dateParser.transform(_('update')(() => undefined)),
    inviter: z
      .object({
        id: z.number(),
        name: z.string().nullish(),
        nameAr: z.string().nullish(),
      })
      .nullish()
      .transform(_('update')(() => undefined)),
    trainerCv: z
      .object({
        qualification: oneToOne(_).nullish(),
        rank: oneToOne(_).nullish(),
      })
      .nullish()
      .transform(_('update')(() => undefined)),
    // trainerCv: null,
    // bankAccount: null,
  })
}
export default personalInfoZ

export const passInfoZ = ({ operation }: { operation: operation }) => {
  const _ = on(operation)

  return z.object({
    password: z.string().nullish().transform(_('update')(set)),
  })
}

const _schema = personalInfoZ({ operation: 'query' })
export type PersonalInfoType = z.infer<typeof _schema>

export const educationZ = (_: any) =>
  z.object({
    id: z
      .number()
      .nullish()
      .transform(_(['update', 'create'])(() => undefined)),
    university: z.string().nullish().transform(_('update')(set)),
    graduationYear: dateParser.transform(_('update')(set)),
    profession: oneToOne(_),
    specialty: oneToOne(_), // same shape as profession
    qualification: oneToOne(_),
  })

const educationZschema = educationZ(on('query'))
export type educationZType = z.infer<typeof educationZschema>

export const professionalSkillsZ = (_: any) =>
  z.object({
    id: z.number().transform(_(['update', 'create'])(() => undefined)),
    placeOfWork: z.string().nullish().transform(_('update')(set)),
    natureOfWork: z.string().nullish().transform(_('update')(set)),
    yearsOfExperience: z.number().nullish().transform(_('update')(set)),
    academicRank: oneToOne(_),
    type: z
      .enum(['academic', 'practicalExperiance'])
      .nullish()
      .transform(_('update')(set)),
  })
export const trainingExperienceZ = (_: any) =>
  z.object({
    id: z.number().transform(_(['update', 'create'])(() => undefined)),
    eventName: z.string().nullish().transform(_('update')(set)),
    executingAgency: z.string().nullish().transform(_('update')(set)),
  })
export const scientificResearchZ = (_: any) =>
  z.object({
    id: z.number().transform(_(['update', 'create'])(() => undefined)),
    description: z.string().nullish().transform(_('update')(set)),
    type: z
      .enum(['conferences', 'journals'])
      .nullish()
      .transform(_('update')(set)),
    role: z.enum(['lead', 'assistant']).nullish().transform(_('update')(set)),
  })

export const cvZ = ({ operation }: { operation: operation }) => {
  const _ = on(operation)

  return z
    .object({
      id: z.number().transform(_(['update', 'create'])(() => undefined)),
      qualification: oneToOne(_),
      rank: oneToOne(_),
      education: z
        .array(educationZ(_))
        .transform(_(['update', 'create'])(() => undefined)),
      professionalSkills: z
        .array(professionalSkillsZ(_))
        .transform(_(['update', 'create'])(() => undefined)),
      trainingExperience: z
        .array(trainingExperienceZ(_))
        .transform(_(['update', 'create'])(() => undefined)),
      scientificResearches: z
        .array(scientificResearchZ(_))
        .transform(_(['update', 'create'])(() => undefined)),
    })
    .nullish()
}

const cvZschema = cvZ({ operation: 'query' })
export type CvType = z.infer<typeof cvZschema>
